import { useEffect, useState } from "react";

export function useMultipleCameras(cameraActive: boolean): boolean {
  const [multiple, setMultiple] = useState(false);
  useEffect(() => {
    const devices = navigator.mediaDevices;
    if (!devices?.enumerateDevices) return;
    let active = true;
    let revision = 0;
    const refresh = async () => {
      const current = ++revision;
      try {
        const inputs = await devices.enumerateDevices();
        const ids = new Set(inputs.filter(input => input.kind === "videoinput" && input.deviceId).map(input => input.deviceId));
        if (active && current === revision) setMultiple(ids.size > 1);
      } catch {
        if (active && current === revision) setMultiple(false);
      }
    };
    void refresh();
    devices.addEventListener?.("devicechange", refresh);
    return () => { active = false; devices.removeEventListener?.("devicechange", refresh); };
  }, [cameraActive]);
  return multiple;
}
